import { fetchPendingUploads } from '@/redux/ducks/document/uploadHelpers'
import orgamax from 'ampersand-app'
import { pick } from 'lodash'

export const TENANT_INFO_KEYS = ['id', 'tenantName', 'companyName', 'subscriptions', 'isDesktopConnected', 'tenantUsersWithoutRoleCount', 'abTestFlag', 'creditorIdentifier', 'companyAddress', 'restores', 'invoiceCount']

// actions
const ACTION_PREFIX = 'tenant/info'
const SET_DATA = `${ACTION_PREFIX}/setData`
const SET_ERROR = `${ACTION_PREFIX}/setError`

// reducer
export default function reducer(state = {}, action) {
  switch (action.type) {
    case SET_DATA:
      const { data } = action
      return Object.assign(state,
        { isTaxConsultant: data.companyType === 'taxconsultant' },
        pick(data, TENANT_INFO_KEYS))
    case SET_ERROR:
      const { error } = action
      return Object.assign({}, state, { error })
    default:
      return state
  }
};

export const updateData = (data) => {
  return {
    type: SET_DATA,
    data,
  }
}

export const setError = (error) => {
  return {
    type: SET_ERROR,
    error,
  }
}

export const fetchData = () => {
  return (dispatch) => {
    return orgamax.user.getTenantInfo()
      .then(({ body: { data } }) => {
        dispatch(updateData(data))
        fetchPendingUploads()
        orgamax.user.setTenantInfo(data, false)
      })
      .catch((error) => {
        dispatch(setError(error))
      })
  }
}

export const refreshToken = (callback) => {
  return (dispatch) => {
    return orgamax.user.refreshToken()
      .catch((error) => {
        dispatch(setError(error))
      })
      .then(() => {
        callback?.()
      })
  }
}
